<template>
  <div style="width: 100%;height: 100%;overflow: auto">

    <div style="display: flex;margin-top: 10px">
      <el-select v-model="year" style="width: 150px;height: 35px" @change="getYearKpiData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="team" style="width: 200px;margin-left: 10px" @change="getYearKpiData">
        <el-option v-for="item in teamList" :label="item.label" :value="item.value" :key="item.value"></el-option>
      </el-select>
      <div class="dimension_amount" :style="salesStyle" @click="getDimensionSalesInfo()">
        销量(套)
      </div>
      <div class="dimension_sales" :style="amountStyle" @click="getDimensionAmountInfo()">
        金额(￥)
      </div>
    </div>
    <div v-for="(item,index) in missionList">
      <div style="margin-top: 10px;font-size: 16px;"><b>{{ index + 1 }}. &nbsp; {{ item.missionName }}：</b></div>

      <div style="margin-top: 10px;background-color: #eeeeee">
        <div style="display: flex;text-align: center;line-height: 35px;font-weight: bold;font-size: 15px">
          <div style="flex: 1;">KPI名称</div>
          <div style="width: 150px" v-if="showDollar">目标(￥)</div>
          <div style="width: 150px" v-else>目标(套)</div>
          <div style="width: 150px;" v-if="showDollar">实际(￥)</div>
          <div style="width: 150px;" v-else>实际(套)</div>
          <div style="width: 150px" v-if="showDollar">缺口(￥)</div>
          <div style="width: 150px" v-else>缺口(套)</div>
          <div style="width: 50px;border-right: 1px solid #a19e9e" v-for="item in 12">{{ item }}</div>
          <div style="width: 100px">YTD进度</div>
          <div style="width: 100px">年度进度</div>
        </div>
        <div v-for="data in item.dataList" style="display: flex;margin-top: 5px;line-height: 30px;text-align: center;">
          <div style="flex: 1;text-align: right;">{{ data.productName }}</div>
          <div style="width: 150px" v-if="showDollar" >{{ data.targetAmount }}</div>
          <div style="width: 150px" v-else >{{ data.targetSales }}</div>
          <div style="width: 150px;" v-if="showDollar" >{{ data.actualAmount }}</div>
          <div style="width: 150px;" v-else >{{ data.actualSales }}</div>
          <div style="width: 150px;" v-if="showDollar" >{{ data.gapAmount }}</div>
          <div style="width: 150px;" v-else >{{ data.gapSales }}</div>
          <div style="width: 600px;position: relative;">
            <el-progress style="position: absolute; top: 50%; transform: translateY(-50%);" :style="getDateStyle()"
                         :show-text="false" color="#ccc" :stroke-width="15" :percentage="100"/>
            <el-progress style="position: absolute; top: 50%; transform: translateY(-50%);" :style="getStyle(data)"
                         :text-inside="true" :stroke-width="15" :percentage="100" :format="format(data)"
                         :color="getColors(data)"/>
            <div style="position:absolute;top: 0;left: 0;width: 100%;height: 100%;display: flex">
              <div v-for="n in 12" style="flex: 1;border-right: 1px solid #a19e9e;"></div>
            </div>
          </div>
          <div style="width: 100px" v-if="showDollar" >{{ data.ytdAmount }}</div>
          <div style="width: 100px" v-else >{{ data.ytd }}</div>
          <div style="width: 100px" v-if="showDollar" >{{ data.annualAmount + '%' }} </div>
          <div style="width: 100px" v-else >{{ data.annual + '%' }}</div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import dayjs from "dayjs";
import isLeapYear from 'dayjs/plugin/isLeapYear';
import dayOfYear from 'dayjs/plugin/dayOfYear';

dayjs.extend(isLeapYear);
dayjs.extend(dayOfYear);

export default {
  name: "YearKpi",

  data() {
    return {
      yearPercentage:0,
      showDollar:true,
      salesStyle:'',
      amountStyle:'',
      year: '',
      team:'',
      yearList: [],
      teamList:[],
      missionList:[
        {
          missionName:'基本任务',
          dataList:[
            { productName: 'SWX', target: '1,697,442', actual: '1,213,120', gap: '-546,668', ytd: '68.9',annualProgress:'68%', annual: '68' },
            { productName: 'Electrical', target: '36,542', actual: '52,361', gap: '-9,639', ytd: '64.9',annualProgress:'88%',  annual: '88' },
            { productName: 'Inspection', target: '2,360', actual: '13,194', gap: '-139,706', ytd: '9%',annualProgress:'8%', annual: '8' },
            { productName: 'MBD', target: '1,740', actual: '45,103', gap: '103.9', ytd: '184%',annualProgress:'176%', annual: '176' },
            { productName: 'CAM', target: '780', actual: '40,303', gap: '-116,123', ytd: '25.9',annualProgress:'27%', annual: '27' },
            { productName: 'DraftSight', target: '18,160', actual: '1,213,120', gap: '-546,668', ytd: '63.9',annualProgress:'72%', annual: '72' },
            { productName: 'Simulation', target: '90,852', actual: '52,361', gap: '-9,639', ytd: '54.9',annualProgress:'88%', annual: '88' },
            { productName: 'Simulation Abaqus', target: '0', actual: '13,194', gap: '-139,706', ytd: '8.9',annualProgress:'9%', annual: '9' },
            { productName: 'Simulation X-flow', target: '0', actual: '45,103', gap: '100.9', ytd: '184%',annualProgress:'176%', annual: '176' },
            { productName: 'Simulation CST', target: '10,000', actual: '40,303', gap: '-116,123', ytd: '25.9', annualProgress:'27%', annual: '27' },
            { productName: 'Plastics', target: '0', actual: '45,103', gap: '103.9', ytd: '184%',annualProgress:'176%', annual: '176' },
            { productName: '本类总计', target: '1,857,876', actual: '45,103', gap: '-812,136', ytd: '84%',annualProgress:'84%', annual: '84' },
          ],
        }
      ],
    }
  },

  async created() {
    await this.calculateCurrentDate();
    await this.getYearList();
    await this.getAllTeam();
    await this.getDimensionAmountInfo();
    await this.getYearKpiData();

  },
  methods: {

    async getYearKpiData(){
      if(!this.year || !this.team){
        return;
      }
      let params = {year:this.year,team:this.team};
      this.missionList = await this.$http('crmTeamService.getYearKpiData',params);

      this.calculateCurrentDate();
    },

    async getAllTeam(){
      this.teamList = await this.$http('crmTeamService.getTeamByRole');
      if(this.teamList){
        this.team = this.teamList[0].value;
      }
    },
    getDimensionSalesInfo(){
      //先改渲染状态
      if(this.amountStyle){
        this.amountStyle = '';
      }
      this.salesStyle = 'background: rgb(4,134,254);color:white';
      //显示金额
      this.showDollar = false;

    },
    getDimensionAmountInfo(){
      //先改渲染状态
      if(this.salesStyle){
        this.salesStyle = '';
      }
      this.amountStyle = 'background: rgb(4,134,254);color:white';
      //显示金额
      this.showDollar = true;

    },
    //计算今天在全年的进度
    calculateCurrentDate(){
      const now = dayjs();
      let year = now.year();
      if(year > parseInt(this.year)){
        this.yearPercentage = 100;
        return;
      }
      const startOfYear = now.startOf('year');
      const endOfYear = now.endOf('year');
      // 计算当前年的天数
      const daysInYear = endOfYear.diff(startOfYear, 'day') + 1;
      // 计算今天是今年的第几天
      const dayOfYear = now.dayOfYear();
      // 计算百分比
      this.yearPercentage = ((dayOfYear / daysInYear) * 100).toFixed(2);
    },
    async getYearList(){
      const now = dayjs();
      this.year = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },
    getColors(item){
      let annual;
      if(this.showDollar){
        annual = item.annualAmount;
      }else {
        annual = item.annual;
      }
      let colors = '';
      if(annual < 25){
        colors = '#f56c6c';
      }
      if(annual >= 25 && annual < 70){
        colors = '#e6a23c';
      }
      if(annual >= 70 && annual < 90) {
        colors = '#1989fa';
      }
      if(annual >= 90){
        colors = '#5cb87a';
      }
      return colors;
    },
    format(item){
      return () => {
        if(this.showDollar){
          return item.annualAmount + '%';
        }else {
          return item.annual + '%';
        }
      }

    },
    getDateStyle(){
      let style = '';
      style = 'width:' + this.yearPercentage + '%;';
      return style;
    },
    getStyle(item){
      let style = '';
      let annual ;
      if(this.showDollar){
        annual = item.annualAmount;
      }else {
        annual = item.annual;
      }
      if(annual > 100){
        annual = 100;
      }
      style = 'width:' + annual + '%;';
      return style;

    },


  }

}
</script>

<style scoped>

.dimension_amount{
  width: 150px;
  line-height: 30px;
  margin-left: 20px;
  border: 1px #cccccc solid;
  text-align: center;
  cursor: pointer
}

.dimension_sales{
  width: 150px;
  line-height: 30px;
  border: 1px #cccccc solid;
  border-left: none;
  text-align: center;
  cursor: pointer
}

</style>